import { Editor, Node, Transforms } from 'slate';
import { getLists } from "../lib/index.js";
/**
 * Sets "type" of all "list" nodes in the current selection.
 */
export function setListType(editor, schema, listType) {
  let at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : editor.selection;
  if (!at) {
    return false;
  }
  const lists = getLists(editor, schema, at);
  if (lists.length === 0) {
    return false;
  }
  const refs = lists.map(_ref => {
    let [_, path] = _ref;
    return Editor.pathRef(editor, path);
  });
  refs.forEach(ref => {
    const path = ref.current;
    const node = path ? Node.get(editor, path) : null;
    if (node && path) {
      Transforms.setNodes(editor, schema.createListNode(listType, node), {
        at: path
      });
    }
    ref.unref();
  });
  return true;
}